import { render, staticRenderFns } from "./WidgetErrorMessage.vue?vue&type=template&id=facb13e0"
import script from "./WidgetErrorMessage.vue?vue&type=script&lang=ts"
export * from "./WidgetErrorMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports